import React, {useEffect, useState} from "react";
import ReactECharts from "echarts-for-react";
const RevenueByPlanChart = ({revenueBySubscriptionPlan = []}) => {
    const [typeId, setTypeId] = useState(1);
    const [data, setData] = useState([]);
    useEffect(() => {
        const res = revenueBySubscriptionPlan.filter(x => x.TypeId === typeId)
            .map(item => {
                return {
                    value: item.TotalRevenues,
                    name: item.ServicePlanName
                }
            });
        setData(res);
    }, [typeId, revenueBySubscriptionPlan]);
    const option = {
        tooltip: { trigger: "item" },
        legend: { bottom: "5%", left: "center" },
        series: [
            {
                name: "Plan",
                type: "pie",
                radius: ["40%", "70%"],
                data: data,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowColor: "rgba(0, 0, 0, 0.2)"
                    }
                }
            }
        ]
    };

    return (
        <div className="card" style={{ height: "450px" }}>
            <div className="card-body">
                <div>
                    <h5>Revenue by Subscription Plan</h5>
                    <p className="fs-9 fw-semibold">Users across countries</p>
                </div>
                <ul className="nav nav-underline mb-3" role="tablist">
                    <li className="nav-item">
                        <a
                            className="nav-link active cursor-pointer"
                            data-bs-toggle="tab"
                            role="tab"
                            aria-selected="true"
                            onClick={() => setTypeId(1)}
                        >
                            Personal Plan
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link cursor-pointer"
                            data-bs-toggle="tab"
                            role="tab"
                            aria-selected="false"
                            onClick={() => setTypeId(2)}
                        >
                            Business Plan
                        </a>
                    </li>
                </ul>
                <div className="tab-content">
                    <ReactECharts className='w-100' option={option} style={{ height: 320 }} />
                </div>
            </div>
        </div>
    );
};
export default RevenueByPlanChart;